import { WORKER_BASE_URL } from './env'
import type { HanziConfig } from '../types'

export interface ShareConfigResponse {
  ok: boolean
  id?: string
  url?: string
  error?: string
  message?: string
}

export interface GetShareConfigResponse {
  ok: boolean
  version?: number
  config?: Partial<HanziConfig>
  error?: string
  message?: string
}

export async function createShortLink(config: HanziConfig): Promise<ShareConfigResponse> {
  const response = await fetch(`${WORKER_BASE_URL}/share-config`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ config }),
  })

  return response.json() as Promise<ShareConfigResponse>
}

export async function fetchShortLink(id: string): Promise<GetShareConfigResponse> {
  const response = await fetch(`${WORKER_BASE_URL}/share-config/${id}`)

  return response.json() as Promise<GetShareConfigResponse>
}
